import { imgs } from '../../assets/imgs'
import { tracking } from '../../utils/tracking'

export const Location = () => {
   return (
      <div className='location'>
         <section>
            <iframe
               title='venue-map'
               src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3022.203234157919!2d-74.00504402352857!3d40.75755453482489!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x89c2596b0b3394a7%3A0x8461e42130f7d0a6!2sJavits%20Center!5e0!3m2!1sen!2sil!4v1688630563445!5m2!1sen!2sil"
               style={{ border: "0", width: "100%", height: "100%" }}
               allowFullScreen
               loading="lazy"
               referrerPolicy="no-referrer-when-downgrade"
            />
            {/* <img src={imgs.venue.venueLocation} alt="" /> */}
         </section>
         <section>
            <h1>Location & Directions</h1>
            <p>Javits Center</p>
            <p>429 11th Ave, New York, NY</p>
            <div className='icons'>
               <a rel='noreferrer' target="_blank" href="https://goo.gl/maps/1wmvQbv3cPUReAZZ9"
                  onClick={() => tracking(295)}
               >
                  <img src={imgs.icons.googleMaps} alt="google-maps" />
               </a>
               <a
                  rel='noreferrer'
                  target="_blank"
                  href="https://ul.waze.com/ul?preview_venue_id=187433368.1874333676.186323&navigate=yes&utm_campaign=default&utm_source=waze_website&utm_medium=lm_share_location"
                  onClick={() => tracking(296)}
               >
                  <img src={imgs.icons.waze} alt="waze" />
               </a>
            </div>
         </section>
      </div>
   )
}
